import type {
	JSX,
} from 'react'
import {
	memo,
} from 'react'

import {
	TypographyCut,
} from '@/shared/components'
import {
	AvatarBase,
} from '@/shared/components/avatar/ui/avatar-base'
import {
	HStack, VStack,
} from '@/shared/components/stack'

import {
	getUserDisplayName,
} from '../../lib/utils'
import {
	HStackRoot,
} from './user-card.styles'
import type {
	IUserCardProps,
} from './user-card.types'

export const UserCard = memo((props: IUserCardProps): JSX.Element => {
	const {
		user,
	} = props

	const displayName = getUserDisplayName(user)
	const hasNickname = Boolean(user?.nickname)

	return (
		<HStackRoot spacing={2} width='100%' alignItems='center'>
			<AvatarBase
				src={user?.telegramAvatarUrl}
				sx={{
					width:  36,
					height: 36,
					border: '2px solid var(--primary-color)',
				}}
			>

			</AvatarBase>
			<VStack spacing={1}>
				<HStack>
					<TypographyCut maxWidth='110px' fontWeight={600} variant='body-x-small'>{displayName}</TypographyCut>
				</HStack>
				{hasNickname && user?.username && (
					<TypographyCut maxWidth='110px' fontWeight={500} variant='body-xs-small'>@{user.username}</TypographyCut>
				)}
				{!hasNickname && user?.username && (
					<TypographyCut maxWidth='110px' fontWeight={500} variant='body-xs-small'>@{user.username}</TypographyCut>
				)}
			</VStack>
		</HStackRoot>
	)
})

UserCard.displayName = 'UserCard'
